import { EventEmitter } from "pixi.js";


export enum EnumEventBus {
  setHowToPlayMode = "SET_HOW_TO_PLAY_MODE",
  spin = "SPIN",
  explAllWFireworks = "EXPLODE_ALL_WELEMENTS",
  setPlayButStatus = "SET_PLAYBUTTON_STATUS",
  setBPlayButStatus = "SET_BONUS_PLAY_BUTTON_STATUS",
  setAPlayButStatus = "SET_AUTO_PLAY_BUTTON_STATUS",
  setTotalWon = "SET_TOTALWON",
  requestAmount = "REQUEST_AMOUNT",
  getAmount = "GET_AMOUNT",
  updateWFireworkTexture = "UPDATE_W_FIREWORK_TEXTURE",
  increaseAmount = "INCREASE_AMOUNT",
  decreaseAmount = "DECREASE_AMOUNT",
  hideEllipses = "HIDE_ELLIPSES",
  setHFType = "SET_HANDLE_FUNCTION_TYPE",
  setLoadingBar = "SET_LOADING_BAR",
  setAllButtonIntractvy = "SET_ALL_BUTTONS_INTERACTIVITY",
  setCountConVis = "SET_AUTO_PLAY_COUNT_CONTAINER_VISIBLE",
  sendCountAmount = "SEND_COUNT_AMOUNT_TO_AUTO_PLAY_BUTTON",
  gameIsCompleted = "GAME_IS_COMPLETED",
  autoGameIsCompleted = "AUTO_GAME_IS_COMPLETED",
  setOptionsPopupVis = "SET_OPTIONS_POPUP_VISIBLE",
  setBonusGame = "SET_BONUS_GAME",
  betAmountStatus = "BET_AMOUNT_STATUS",
  setManuelExplode = "SET_MANUEL_EXPLODE",
  setTgleMlAndAutoBut = "SET_TOGGLE_MANUEL_AND_AUTO_BUTTON",
  setStopBarCount = "SET_STOP_BAR_COUNT"
}


export const EventBus = new EventEmitter(); 